import React, { useEffect, useState } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs, addDoc, Timestamp, query, orderBy, where } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyC58VKfUUehF4BqwkfFwunvTaGZgyhDtQU",
  authDomain: "crm-leads-shippix.firebaseapp.com",
  projectId: "crm-leads-shippix",
  storageBucket: "crm-leads-shippix.firebasestorage.app",
  messagingSenderId: "359918388635",
  appId: "1:359918388635:web:ccec48d954454cb98e4d3e",
  measurementId: "G-PVL81XXNT2"
};

const app = initializeApp(firebaseConfig, 'support-tickets');
const db = getFirestore(app);

interface TicketDetailProps {
  ticket: any;
  onBack: () => void;
  userName: string;
  userEmail: string;
}

export default function TicketDetail({ ticket, onBack, userName, userEmail }: TicketDetailProps) {
  const [messages, setMessages] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [reply, setReply] = useState('');
  const [sending, setSending] = useState(false);

  useEffect(() => {
    const fetchMessages = async () => {
      setLoading(true);
      const q = query(
        collection(db, 'ticketMessages'),
        where('ticketId', '==', ticket.id),
        orderBy('createdAt', 'asc')
      );
      const querySnapshot = await getDocs(q);
      setMessages(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      setLoading(false);
    };
    fetchMessages();
  }, [ticket.id]);

  const sendReply = async () => {
    if (!reply.trim()) return;
    setSending(true);
    await addDoc(collection(db, `tickets/${ticket.id}/ticketMessages`), {
      content: reply,
      createdAt: Timestamp.now(),
      ticketId: ticket.id,
      type: 'message',
      userEmail,
      userName,
    });
    setReply('');
    // Recarregar mensagens
    const q = query(
      collection(db, 'ticketMessages'),
      where('ticketId', '==', ticket.id),
      orderBy('createdAt', 'asc')
    );
    const querySnapshot = await getDocs(q);
    setMessages(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    setSending(false);
  };

  return (
    <div>
      <button className="mb-2 text-sm text-blue-600 underline" onClick={onBack}>← Voltar à lista</button>
      <h2 className="text-lg font-semibold mb-2">{ticket.assunto || ticket.subject}</h2>
      <div className="mb-2 text-xs text-gray-500 flex gap-4 flex-wrap">
        <span><span className="font-semibold">Estado:</span> {ticket.statusName || ticket.status}</span>
        <span><span className="font-semibold">Criado em:</span> {ticket.createdAt?.toDate?.().toLocaleString?.() || ''}</span>
        <span><span className="font-semibold">Cliente:</span> {ticket.nomeCliente} ({ticket.email})</span>
        <span><span className="font-semibold">Empresa:</span> {ticket.empresa}</span>
      </div>
      <div className="mb-2"><span className="font-semibold">Descrição:</span> {ticket.descricao}</div>
      {/* Anexos do ticket */}
      {ticket.anexos && ticket.anexos.length > 0 && (
        <div className="mb-2">
          <span className="font-semibold">Anexos do ticket:</span>
          <ul className="list-disc ml-4">
            {ticket.anexos.map((anexo: any, idx: number) => (
              <li key={idx}>
                <a href={anexo.url} target="_blank" rel="noopener noreferrer" className="text-blue-700 underline">
                  {anexo.name || `Anexo ${idx + 1}`}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="border rounded p-3 bg-gray-50 mb-4">
        {loading ? 'A carregar mensagens...' : (
          <div className="space-y-2">
            {messages
              .filter(msg => typeof msg.content === 'string' ? !msg.content.toLowerCase().includes('estado do ticket alterado') : true)
              .map(msg => (
                <div key={msg.id} className={`p-2 rounded shadow text-sm flex gap-3 ${msg.userEmail === ticket.email ? 'bg-blue-50' : 'bg-white'}`}
                  style={{ alignItems: 'flex-start', borderLeft: msg.userEmail === ticket.email ? '4px solid #2196f3' : '4px solid #e0e0e0' }}>
                  <div>
                    <div className="font-semibold text-gray-700">{msg.userName}</div>
                    <div dangerouslySetInnerHTML={{ __html: msg.content }} />
                    {/* Anexos da mensagem */}
                    {msg.anexos && msg.anexos.length > 0 && (
                      <div className="mt-1">
                        <span className="font-semibold">Anexos:</span>
                        <ul className="list-disc ml-4">
                          {msg.anexos.map((anexo: any, idx: number) => (
                            <li key={idx}>
                              <a href={anexo.url} target="_blank" rel="noopener noreferrer" className="text-blue-700 underline">
                                {anexo.name || `Anexo ${idx + 1}`}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    <div className="text-xs text-gray-400 mt-1">{msg.createdAt?.toDate?.().toLocaleString?.() || ''}</div>
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>
      <div className="flex flex-col gap-2 bg-white p-4 rounded shadow border mt-4">
        <textarea
          className="border rounded p-2 w-full"
          rows={2}
          placeholder="Responder ao ticket..."
          value={reply}
          onChange={e => setReply(e.target.value)}
          style={{ resize: 'vertical', minHeight: 50 }}
        />
        <button
          className="px-4 py-2 bg-primary text-white rounded self-end shadow-md hover:bg-blue-700 transition"
          onClick={sendReply}
          disabled={sending || !reply.trim()}
        >{sending ? 'A enviar...' : 'Enviar resposta'}</button>
      </div>
    </div>
  );
}
